import CancelOrganisationInvitationConfirmation from './CancelOrganisationInvitationConfirmation';

export default CancelOrganisationInvitationConfirmation;
